export function isValidReturnUrl(raw: string | null | undefined): boolean {
  if (!raw) return false;

  // Server-relative only — reject absolute URLs to avoid open-redirect.
  if (!raw.toLowerCase().startsWith('/connect/authorize')) return false;

  const queryIndex = raw.indexOf('?');
  if (queryIndex < 0) return false;

  const params = new URLSearchParams(raw.slice(queryIndex + 1));
  return (
    params.has('client_id') &&
    params.has('redirect_uri') &&
    params.has('response_type')
  );
}
